document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-accordion').forEach(accordion => {
    const height = accordion.scrollHeight;
    accordion.setAttribute('data-height', height);
    accordion.style.height = `${height}px`;
  });

  document.querySelectorAll('.js-toggle-accordion').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const accordion = button.closest('.js-accordion');
      const savedHeight = accordion.getAttribute('data-height');

      if (accordion.classList.contains('active')) {
        accordion.classList.remove('active');
        accordion.classList.add('deactivate');
        accordion.style.height = `${savedHeight}px`;

        setTimeout(() => {
          accordion.classList.remove('deactivate', 'display');
        }, 300);
      } else {
        accordion.classList.add('display');

        setTimeout(() => {
          const height = accordion.scrollHeight;
          accordion.style.height = `${height}px`; 
          accordion.classList.add('active');
        }, 10);
      }
    });
  });
});